import { AnimatePresence, motion } from "framer-motion";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import defaultImage from "../../../assets/clientIcon.png"

export default function PodcastDelete({ setIsDeleteModal, isDeleteModal }) {
  const dispatch = useDispatch();

  

  const { podcast } = useSelector((state) => state.podcast);

  return (
    <AnimatePresence>
      {isDeleteModal && (
        <motion.div
          key="modal-background"
          onClick={() => setIsDeleteModal(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background font-poppina rounded-lg shadow-lg p-6 w-[400px] mx-4 "
          >
            <div className="flex justify-end">
              <button
                onClick={() => setIsDeleteModal(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <div className="flex flex-col items-center space-y-4">
              <div className="p-4 bg-red-50 rounded-full">
                <TrashIcon className="w-10 h-10 text-red-500" />
              </div>
              
              <h1 className="text-xl font-semibold text-text text-center">
                ¿Eliminar a {podcast.name} ?
              </h1>

              
            </div>
            <div className="flex justify-center space-x-4 mt-6">
              <button onClick={() => setIsDeleteModal(false) } className="px-6 py-2 text-gray-700 rounded-lg border border-gray-700 hover:bg-gray-50 transition-colors">
                Cancelar
              </button>
              <button className="px-6 py-2 text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors">
                Eliminar
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
